import { createModel } from "@@/package/utils/ModelUtil";
import Model from "@@/package/mapper/Model";

export class CourseSkillModel extends Model {
  constructor(
    public id: number = 0,
    public title: string = "",
    public exerciseCount: number = 0,
    public totalLearningTime: number = 0,
    public totalPoint: number = 0,
    public completedExerciseCount: number = 0,
    public completedAllFlag: boolean = false,
    public link: string = ""
  ) {
    super();
  }

  public static create(model: Partial<CourseSkillModel>): CourseSkillModel {
    return createModel<CourseSkillModel>(CourseSkillModel, {
      ...model
    });
  }
}
